/**
 * @generated SignedSource<<5dfe840b5f80c29155dae6fb3eb5e0f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ViewInRoom_item$data = {
  readonly description: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoomImageCredits_item" | "ViewInRoomImage_item">;
  readonly " $fragmentType": "ViewInRoom_item";
};
export type ViewInRoom_item$key = {
  readonly " $data"?: ViewInRoom_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoom_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoom_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImage_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImageCredits_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "66d0eae4a068d452e9f35fcb65a12eb9";

export default node;
